import { render, staticRenderFns } from "./SleepWorkshop.vue?vue&type=template&id=1c3cbe76"
import script from "./SleepWorkshop.vue?vue&type=script&lang=js"
export * from "./SleepWorkshop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports